import {PropsWithChildren} from "react";

type Props = {
    title: string
    noPaddingLeft?: boolean
}

const Section = (props:PropsWithChildren<Props>) =>{
    return (
        <section className={"w-full text-left mt-10 first:mt-0"}>
            <h2 className={"text-2xl font-bold tracking-tight sm:text-3xl"}>{props.title}</h2>
            <div className={"mt-1.5 mb-4 h-[3px] w-12 rounded-full bg-accent"}/>
            <div className={"text-base leading-relaxed sm:text-lg"}>{props.children}</div>
        </section>
    )
}

export default Section
